// src/services/pageService.ts
import api from './axios';

interface PageContentCreationData {
  // Define properties needed for creating page content
}

interface PageContentUpdateData {
  // Define properties needed for updating page content
}

export const createPageContent = async (data: PageContentCreationData) => {
  const response = await api.post('/pages/create', data);
  return response.data;
};

export const getPageContentByTemplateId = async (templateId: string, language: string) => {
  const response = await api.get(`/pages/get-by-template/${templateId}`, {
    params: { language },
  });
  return response.data;
};

export const getPageContentById = async (id: string, language: string) => {
  const response = await api.get(`/pages/get/${id}`, {
    params: { language },
  });
  if (response.status === 200) {
    return { success: true, data: response.data.data };
  }
  return { success: false, data: response.data.message };
};

export const getPagesByTemplateId = async (templateId: string, page: number, limit: number) => {
  const response = await api.get(`/pages/get-pages/${templateId}`, {
    params: { page, limit },
  });
  return response.data;
};

export const updatePageContent = async (data: PageContentUpdateData) => {
  const response = await api.put(`/pages/update`, data);
  return response.data;
};

export const deletePageContent = async (id: string) => {
  const response = await api.delete(`/pages/delete/${id}`);
  return response.data;
};

/*
  Drafts Services
*/

export const getDraftByPageId = async (pageId: string, language: string) => {
  try {
    const response = await api.get(`/pages/draft/${pageId}`, {
      params: { language },
    });
    if (response.status === 200) {
      return { success: true, data: response.data.data };
    }
    return { success: false, data: response.data };
  } catch (error) {
    console.error('Error retrieving draft:', error);
    throw error;
  }
};

export const publishDraft = async (pageId: string, language: string) => {
  try {
    const response = await api.post('/pages/publish', { pageId, language });
    if (response.status === 200) {  
      return { success: true, data: response.data };
    }
    return { success: false, data: response.data };
  } catch (error) {
    console.error('Error publishing draft:', error);
    throw error;
  }
};

// discard draft
export const discardDraft = async (pageId: string) => {
  const response = await api.delete(`/pages/discard/${pageId}`);
  if (response.status === 200) {
    return { success: true, data: response.data.message };
  }
  return { success: false, data: response.data.message };
};